var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignDateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M13.333 2h-.666V.667h-1.334V2H4.667V.667H3.333V2h-.666c-.734 0-1.334.6-1.334 1.334V14c0 .734.6 1.334 1.334 1.334h10.666c.734 0 1.334-.6 1.334-1.334V3.334c0-.734-.6-1.334-1.334-1.334Zm0 12H2.667V5.334h10.666V14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignDateIcon);
export default __webpack_public_path__ + "static/media/sign-date-icon.de276e56ef5ec6498df4de0a3259bcd7.svg";
export { ForwardRef as ReactComponent };